(async () => {
  const { routes, text } = await import('@theme/lb-ui');
  function run(root = document) {
    const main = document.querySelector('main');
    if (!main || !main.querySelector('product-form-component')) return;
    const details = main.querySelector('.product-details,product-information,.product-information');
    if (!details || details.querySelector('.lb-delivery-note')) return;
    const note = document.createElement('div');
    note.className = 'lb-delivery-note';
    note.textContent = text('delivery_note');
    const form = details.querySelector('product-form-component');
    (form || details).insertAdjacentElement(form ? 'afterend' : 'beforeend', note);
    const links = document.createElement('div');
    links.className = 'lb-trust-links';
    for (const [key, url] of [['size_guide', routes.size], ['shipping_info', routes.shipping]]) {
      if (!url) continue;
      const link = document.createElement('a'); link.href = url; link.textContent = text(key); links.append(link);
    }
    note.insertAdjacentElement('afterend', links);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
})();
